import React from "react";
import classNames from "classnames";
import { useTheme } from "./theme";
import { useI18n } from "../lib/i18n/i18n_provider";

export type HeadingSize = "xl" | "lg" | "md" | "sm";
export interface HeadingProps {
  children?: React.ReactNode;
  size?: HeadingSize;
  align?: "left" | "right" | "center";
  customColor?: string;
  className?: string;
}

/**
 * Run of heading with a single style.
 */
export function Heading(props: HeadingProps) {
  const { align, children, size = "md", customColor, className } = props;
  const theme = useTheme();
  const { locale } = useI18n();
  const headingProps = {
    className: classNames(
      "heading",
      size && `heading-size-${size}`,
      align && `heading-align-${align}`,
      `heading-${locale.baseLanguageTag}`,
      className
    ),
    style: {
      fontFamily: theme.fontFamilyHeading,
      ...(customColor && { color: customColor }),
    },
    children,
  };

  switch (size) {
    case "xl": {
      return <h1 {...headingProps}> {headingProps.children} </h1>;
    }
    case "lg": {
      return <h2 {...headingProps}> {headingProps.children} </h2>;
    }
    case "md": {
      return <h3 {...headingProps}> {headingProps.children} </h3>;
    }
    default: {
      return <h4 {...headingProps}> {headingProps.children} </h4>;
    }
  }
}
